// extracted by mini-css-extract-plugin
export default {"loader":"SpinnerButton_loader__PcLMJ","relative":"SpinnerButton_relative__2mU-v","hideText":"SpinnerButton_hideText__8iqnN"};